import { useState } from 'react';
import { Col, Row } from 'reactstrap';
import Table, { useTable } from 'common/components/table';
import company from 'assets/svg/actions/company.svg';

import TableActions from 'components/layouts/table';

import edit from 'assets/svg/actions/edit.svg';

import useDrawer from 'common/components/drawer/useDrawer';
import Form from './form';
import EnumsDropdown from '../Dropdown';
import NamesInTooltip from '@/library/components/general/NamesInTooltip';

const CrewIdentifiers = () => {
  const [active, setActive] = useState(null);
  const [editType, setEdit] = useState(null);

  const drawer = useDrawer();

  const table = useTable({
    label: 'crew_identifiers',
    columns: [
      {
        header: 'Name',
        key: 'name',
        type: 'string',
        width: 4,
        sort: true
      },
      {
        header: 'Type',
        key: 'type',
        type: 'string',
        sort: true
      },
      {
        header: 'Visibility',
        key: 'hidden_by_default',
        type: 'string',
        canFilter: false,
        sort: true
      },
      {
        header: 'Blacklisted/Whitelisted',
        key: 'listed',
        type: 'string',
        canFilter: false,
        sort: false
      },
      {
        header: 'Actions',
        key: 'actions',
        field: 'actions',
        className: 'text-center',
        width: 1
      }
    ]
  });

  return (
    <Row className="crew_identifiers-table">
      <Col xs={12} className="mb-6 mt-n1">
        <TableActions
          documentTitle="Crew Identifiers"
          title="Enums"
          dropdown={<EnumsDropdown />}
          actions={[
            { type: 'search' },
            {
              type: 'add',
              text: 'Add Identifier',
              color: 'primary',
              onClick: () => {
                setActive(null);
                drawer.open();
              }
            }
          ]}
        />
      </Col>
      <Col xs={12}>
        <Table
          loader
          drawer={<Form drawer={drawer} active={active} editType={editType} />}
          rows={{
            coordinates: data => (
              <div>
                {data.lat} / {data.lon}
              </div>
            ),
            hidden_by_default: data => (
              <div>{data.hidden_by_default ? 'Hide by default' : 'Show by default'}</div>
            ),
            listed: data => (
              <div>
                {data.whitelist?.length || data.blacklist?.length ? (
                  data.hidden_by_default ? (
                    <NamesInTooltip names={data.whitelist.map(item => item.name)} maxLimit={4} />
                  ) : (
                    <NamesInTooltip names={data.blacklist.map(item => item.name)} maxLimit={4} />
                  )
                ) : (
                  '-'
                )}
              </div>
            ),
            actions: () => ({
              options: [
                {
                  label: 'Edit',
                  icon: edit,
                  onClick: (_, row) => {
                    setEdit('edit');
                    setActive(row);
                    drawer.open();
                  }
                },
                {
                  label: 'Edit Visibility',
                  icon: company,
                  onClick: (_, row) => {
                    setEdit('visibility');
                    setActive(row);
                    drawer.open();
                  }
                }
              ]
            })
          }}
          {...table}
        />
      </Col>
    </Row>
  );
};

export default CrewIdentifiers;
